import React from "react";

export const constants = {
  headerProps: {
    id: { title: "id", hidden: true },
    payer: { title: "Payer", fixedLeft: true, isLocked: true },
  },
  featureInfo: <React.Fragment>Please note, TBD.</React.Fragment>,
};
